module.exports = __webpack_public_path__ + "static/divider16-1ca32c200f6e5b476f3760deda1fa8e3.svg";